import { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { endsWithClosingQuote, startsWithOpeningQuote } from '../../utils/i18n/quotationStyleUtils';

/**
 * Decorative blockquote quotes are rendered via CSS: an opening quote before the first
 * paragraph and a closing quote after the last paragraph.
 *
 * When the text is already wrapped in quotes we want to hide the decorative quotes to
 * avoid doubling them up. To stay predictable, we only do so when the content is fully
 * enclosed: it starts with a known opening quote AND ends with a known closing quote.
 */
export const shouldOmitQuotesForBlockquoteText = (firstParagraphText: string, lastParagraphText: string): boolean =>
    startsWithOpeningQuote(firstParagraphText) && endsWithClosingQuote(lastParagraphText);

/**
 * Determines whether a blockquote node's decorative quotes should be hidden because its
 * text is already wrapped in quotes.
 */
export const shouldOmitBlockquoteQuotes = (blockquote: ProseMirrorNode): boolean => {
    const firstParagraph = blockquote.firstChild;
    const lastParagraph = blockquote.lastChild;

    if (!firstParagraph || !lastParagraph) return false;

    return shouldOmitQuotesForBlockquoteText(firstParagraph.textContent, lastParagraph.textContent);
};
